// extracted by mini-css-extract-plugin
export default {"container":"ExpiryDateInput_container__ODg46","switch":"ExpiryDateInput_switch__ujGXT","rules":"ExpiryDateInput_rules__7SLAg","title":"ExpiryDateInput_title__AWgMg"};